import { IBreakpointsEnum } from "@constants";
import { isMobileApp, useMinMedia } from "@utils";

export const useMobile = () => {
  const isDesktop = useMinMedia(IBreakpointsEnum.MD);
  const isMobile = isMobileApp && !isDesktop;

  return { isMobileApp, isMobile } as const;
};
